import {
  GET_TEAM,
  CREATE_TEAM_MEMBER,
  UPDATE_TEAM_MEMBER,
  DELETE_TEAM_MEMBER,
  UPDATE_TEAM_MEMBER_AGENDA
} from '../constants';
import { ITeamMember } from '../reducers';

export function getTeam(resolve: any, reject: any) {
  return {
    type: GET_TEAM,
    resolve,
    reject
  };
}

export function createTeamMember(teamMember: ITeamMember, resolve: any, reject: any) {
  return {
    type: CREATE_TEAM_MEMBER,
    teamMember,
    resolve,
    reject
  };
}

export function updateTeamMember(teamMember: ITeamMember, resolve: any, reject: any) {
  return {
    type: UPDATE_TEAM_MEMBER,
    teamMember,
    resolve,
    reject
  };
}

export function deleteTeamMember(teamMember: ITeamMember, resolve: any, reject: any) {
  return {
    type: DELETE_TEAM_MEMBER,
    teamMember,
    resolve,
    reject
  };
}

export function updateTeamMemberAgenda(index: number, updates: Partial<ITeamMember>) {
  return {
    type: UPDATE_TEAM_MEMBER_AGENDA,
    payload: { index, updates }
  };
}
